export const PAYMENT_STATUS = {
  OK: 'OK',
  PENDING: 'PENDING',
  CANCEL: 'CANCEL',
  ERROR: 'ERROR',
};

export function isStatusSuccess(status) {
  return /APPROVED|SUCCESS/.test(status) || status === 'OK';
}

export function isStatusPending(status) {
  return /PENDING/.test(status);
}

export function isStatusCanceled(status) {
  return /CANCEL/.test(status);
}
